import { render, staticRenderFns } from "./component-c669ebd7.vue?vue&type=template&id=949b98a4&scoped=true&"
import script from "./component-c669ebd7.vue?vue&type=script&lang=js&"
export * from "./component-c669ebd7.vue?vue&type=script&lang=js&"
import style0 from "./component-c669ebd7.vue?vue&type=style&index=0&id=949b98a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949b98a4",
  null
  
)

export default component.exports